export default "__VITE_ASSET__DOLJmMo8__"